module.exports = __webpack_public_path__ + "static/media/the-container-store-large.b57f286a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/the-container-store-large.png
// module id = 859
// module chunks = 27